<template>
  <div class="statistics-table">
    <PivotComponent
      v-if="contentData"
      v-model="internalPivotConfig"
      :data="contentData.data"
      :dimensions="contentData.dimensions"
      :data-card="dataCard"
      mode="edit"
      component="table"
      :default-pivot-config="defaultPivotConfig"
      :table-edit-open="tableEditOpen"
      :current-search-count="currentSearchCount"
      :total-search-count="totalSearchCount"
      @toggle-edit="toggleTableEdit"
      @change-search-count="(val, total) => {
        $emit('change-search-count', val, total)
      }"
    />
  </div>
</template>

<script>
import PivotComponent from './PivotComponent.vue'
// import { createDefaultPivotConfig } from '@/utils/dimensionUtils.js'
export default {
  components: { PivotComponent },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: {
    dataCard: {
      type: Object,
    },
    pivotConfig: {
      type: Object,
    },
    currentSearchCount: {
      type: Number,
    },
    totalSearchCount: {
      type: Number,
    },
    contentData: {
      type: Object,
    },
  },
  data() {
    return {
      tableEditOpen: false,
      defaultPivotConfig: null, //pivotConfigFile
    }
  },
  computed: {
    internalPivotConfig: {
      get() {
        return this.pivotConfig
      },
      set(value) {
        this.$emit('change', value)
      },
    },
  },
  watch: {
    // contentData: {
    //   handler(value) {
    //     if (!value) return
    //     this.setDefaultConfigs()
    //   },
    //   immediate: true,
    // },
    internalPivotConfig: {
      handler(value) {
        this.$emit('change', value)
      },
      deep: true,
    },
  },
  methods: {
    // setDefaultConfigs() {
    //   if (!this.defaultPivotConfig) {
    //     this.defaultPivotConfig = createDefaultPivotConfig(this.contentData.dimensions, null)
    //     this.internalPivotConfig = JSON.parse(JSON.stringify(this.defaultPivotConfig))
    //   } else {
    //     this.internalPivotConfig = createDefaultPivotConfig(this.contentData.dimensions, null)
    //   }
    //   console.log('Pivot Config', this.internalPivotConfig)
    // },
    toggleTableEdit() {
      this.tableEditOpen = !this.tableEditOpen
    },
  },
}
</script>

<style lang="stylus" scoped>
.statistics-table
  min-height: 60vh
  width: 100%
</style>
